module.exports = __webpack_public_path__ + "img/teacher_11.bc7c98f6.png";